import { render, staticRenderFns } from "./videoshow.vue?vue&type=template&id=2a65abdc&scoped=true"
import script from "./videoshow.vue?vue&type=script&lang=js"
export * from "./videoshow.vue?vue&type=script&lang=js"
import style0 from "./videoshow.vue?vue&type=style&index=0&id=2a65abdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a65abdc",
  null
  
)

export default component.exports